import { IRescheduleEligibilityRepository } from 'shared/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisRescheduleEligibilityRepository from './implementations/VectisRescheduleEligibilityRepository';

let instance: IRescheduleEligibilityRepository | null = null;

export default function makeRescheduleEligibilityRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider();

    instance = new VectisRescheduleEligibilityRepository(httpProvider);
  }

  return instance;
}
